import { render, staticRenderFns } from "./PreviewCreateStoryboard.vue?vue&type=template&id=0db8f7e1&lang=pug"
import script from "./PreviewCreateStoryboard.vue?vue&type=script&lang=js"
export * from "./PreviewCreateStoryboard.vue?vue&type=script&lang=js"
import style0 from "./PreviewCreateStoryboard.vue?vue&type=style&index=0&id=0db8f7e1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports